import gql from "graphql-tag";

export const MY_HR_REGISTER_2FA_TOTP = gql`
  mutation register2faTOTP($email: String!) {
    register2faTOTP(email: $email) {
      status
      qrCode
      otpauth_url
      secret
    }
  }
`;
